import { useEffect, useState } from "react";
import axios from "axios";

// 🔥 نعمل instance للـ axios
const axiosInstance = axios.create({
  baseURL: "http://localhost:8800/api", // backend port
});

const useFetch = (url) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get(url); // 👈 استعمل axiosInstance
      setData(res.data);
      setError(false);
    } catch (err) {
      setError(true);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [url]); // 👈 الأفضل تربطها بالـ url

  const reFetch = async () => {
    await fetchData();
  };

  return { data, loading, error, reFetch };
};

export default useFetch;

